import React, { useState, useEffect } from 'react';
import { Star, Quote, MessageCircle, Building, Home, ArrowLeft, ArrowRight } from 'lucide-react';
import { mockTestimonials } from '../mock';

const TestimonialsPage = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  // Extended testimonials data
  const allTestimonialsRaw = [
    ...mockTestimonials,
      {
    id: 1,
    name: "Imran Zyn",
    rating: 5,
    comment: "The construction quality of the property is excellent, with the use of well-finished wire-cut bricks that enhance both durability and aesthetics. The craftsmanship is evident in the smooth and uniform finish, ensuring a sturdy and visually appealing structure. Additionally, the customer service is commendable, with a professional and responsive team that addresses queries efficiently. Their commitment to quality and customer satisfaction makes the overall experience smooth and reliable…Highly recommended",
    image: "pics/team/icon.webp"
  },
  {
    id: 2,
    name: "Mr.Jayapraksh - Aeronautical Professor Sathyabama",
    rating: 5,
    comment: "A fantastic builder with a reputation for being transparent and customer friendly. Approachable 24X7, they have a dedicated team for every department to ensure that quality is uncompromised. For NPSH, it’s not merely a contract or sale but a relation, in which they ensure that they address any issue we may face at any point of time. I would definitely recommend NPSH to all property buyers and assure for the fact that NPSH is a builder you can trust.",
    image: "pics/testimonials with pics/jayaprakash.webp"
  },
  {
    id: 2,
    name: "siva kumar",
    rating: 5,
    comment: "Great work done by the sales team! They assisted us completely right from the start which made us very comfortable. Thank you,",
    image: "pics/team/icon.webp"
  },
  {
    id: 3,
    name: "krishna prasad",
    rating: 5,
    comment: "Best price with good quality construction, good staff, within budget price. Thank you NPSH.",
    image: "pics/team/icon.webp"
  },
  {
    id: 4,
    name: "Murugan Monisha",
    rating: 5,
    comment: "Their response was superfast and speedy. Coordination with client and team is good.",
    image: "pics/team/icon.webp"
  },
  {
    id: 5,
    name: "STELLA JAYARANI",
    rating: 5,
    comment: "Best price with good quality construction, good staff, within budget price.",
    image: "pics/team/icon.webp"
  },
  {
    id: 6,
    name: "Jacob Joshva",
    rating: 5,
    comment: "He was creative and responsive to the owners as well as to the design and construction team",
    image: "pics/team/icon.webp"
  },
  {
    id: 7,
    name: "Bala Krishnan",
    rating: 5,
    comment: "Best service best construction best response",
    image: "pics/team/icon.webp"
  },
  {
    id: 8,
    name: "Mrs. Binu Vinod Kumar",
    rating: 5,
    comment: "I am pleased with the quality of construction. The materials used and the attention to detail are evident throughout the house. The team was generally responsive and kept me updated on the progress. The project was completed close to the estimated timeline, which I appreciate. I am very happy with my new home. It meets my expectations and need. I look forward to many years here.",
    image: "pics/testimonials with pics/binu.webp",
    project: "NPSH NAVITA",
    category: "Homeowner Review"
  },
  {
    id: 9,
    name: "Mr. Sivasenthil",
    rating: 5,
    comment: "Our dream home became a reality thanks to this builder. They listened to our needs, gave honest advice, and delivered exactly what was promised. We could not be happier with the result.",
    image: "pics/testimonials with pics/sivasenthi.webp",
    project: "NPSH NATPA",
    category: "Homeowner Review"
  },
  {
    id: 10,
    name: "Mr. Vijaysankar",
    rating: 5,
    comment: "We are extremely happy with the quality of construction and attention to detail. The builder was professional, transparent, and completed the project on time. Highly recommended.",
    image: "pics/testimonials with pics/vijaysankar.webp",
    project: "NPSH NAVITA",
    category: "Homeowner Review"
  },
  {
    id: 11,
    name: "Mrs. Ramesh",
    rating: 5,
    comment: "Working with this builder was a smooth and stress-free experience. From planning to execution, everything was handled with professionalism. The quality of materials and workmanship exceeded our expectations.",
    image: "pics/testimonials with pics/ramesh.webp",
    project: "NPSH NAVITA",
    category: "Homeowner Review"
  }
  ];

  const prioritizedIds = new Set([8, 9, 10, 11]);
  const allTestimonials = [...allTestimonialsRaw].sort(
    (a, b) => Number(prioritizedIds.has(b.id)) - Number(prioritizedIds.has(a.id))
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % allTestimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [allTestimonials.length]);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/919884611368?text=Hello, I saw the testimonials and would like to know more about NPSH Developers projects', '_blank');
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % allTestimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + allTestimonials.length) % allTestimonials.length);
  };

  const stats = [
    { value: "100+", label: "Happy Customers", icon: Home },
    { value: "10+", label: "Projects Completed", icon: Building },
    { value: "4.9/5", label: "Average Rating", icon: Star },
    { value: "98%", label: "Customer Satisfaction", icon: Quote }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-yellow-50 to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl lg:text-6xl font-bold text-yellow-600 mb-6">
              Customer Stories
            </h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Hear from our valued customers who have made their dreams come true with NPSH Developers. 
              Their success stories are our greatest achievement.
            </p>
          </div>

          {/* Stats Section */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div
                  key={index}
                  className="text-center p-6 bg-white rounded-2xl shadow-lg border-2 border-gray-100 hover:border-yellow-600 transition-all duration-300"
                >
                  <div className="mb-4 flex justify-center">
                    <div className="w-16 h-16 bg-yellow-100 rounded-2xl flex items-center justify-center">
                      <IconComponent className="h-8 w-8 text-yellow-600" />
                    </div>
                  </div>
                  <p className="text-3xl font-bold text-gray-800 mb-2">{stat.value}</p>
                  <p className="text-gray-600 font-medium">{stat.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Featured Testimonial */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-yellow-600 mb-4">Featured Testimonial</h2>
            <div className="w-24 h-1 bg-yellow-600 mx-auto rounded"></div>
          </div>

          {allTestimonials.length > 0 && (
            <div className="relative">
              <div className="bg-gradient-to-br from-yellow-50 to-white p-12 rounded-3xl shadow-2xl border-2 border-yellow-100">
                <div className="flex justify-center mb-8">
                  <Quote className="h-16 w-16 text-yellow-600 opacity-50" />
                </div>

                <div className="mb-8">
                  <img
                    src={allTestimonials[currentTestimonial]?.image}
                    alt={allTestimonials[currentTestimonial]?.name}
                    className="w-auto max-w-full h-auto max-h-[28rem] mx-auto object-contain bg-white rounded-2xl border-2 border-yellow-200 p-2"
                  />
                </div>
                
                <blockquote className="text-2xl text-gray-700 italic leading-relaxed text-center mb-8 max-w-4xl mx-auto">
                  "{allTestimonials[currentTestimonial]?.comment}"
                </blockquote>
                
                <div className="flex items-center justify-center mb-6">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-6 w-6 text-yellow-400 fill-current mx-1" />
                  ))}
                </div>
                
                <div className="text-center">
                  <h4 className="text-2xl font-bold text-gray-800 mb-1">
                    {allTestimonials[currentTestimonial]?.name}
                  </h4>
                  <p className="text-yellow-600 font-semibold mb-1">
                    {allTestimonials[currentTestimonial]?.designation}
                  </p>
                  <p className="text-gray-600">
                    {allTestimonials[currentTestimonial]?.project}
                  </p>
                </div>
              </div>
              
              {/* Navigation Controls */}
              {allTestimonials.length > 1 && (
                <>
                  <button
                    onClick={prevTestimonial}
                    className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white hover:bg-yellow-50 p-4 rounded-full shadow-lg border-2 border-gray-200 hover:border-yellow-600 transition-all duration-200"
                  >
                    <ArrowLeft className="h-6 w-6 text-yellow-600" />
                  </button>
                  <button
                    onClick={nextTestimonial}
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white hover:bg-yellow-50 p-4 rounded-full shadow-lg border-2 border-gray-200 hover:border-yellow-600 transition-all duration-200"
                  >
                    <ArrowRight className="h-6 w-6 text-yellow-600" />
                  </button>
                </>
              )}
              
              {/* Testimonial Indicators */}
              <div className="flex justify-center mt-8 space-x-3">
                {allTestimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-4 h-4 rounded-full transition-all duration-200 ${
                      currentTestimonial === index 
                        ? 'bg-yellow-600 scale-125' 
                        : 'bg-gray-300 hover:bg-yellow-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* All Testimonials Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-yellow-600 mb-4">What Our Customers Say</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Read more testimonials from our satisfied customers across different project categories.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {allTestimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`bg-white p-8 rounded-2xl shadow-lg border-2 transition-all duration-300 hover:shadow-xl transform hover:scale-105 ${
                  index === currentTestimonial 
                    ? 'border-yellow-600 ring-4 ring-yellow-100' 
                    : 'border-gray-100 hover:border-yellow-600'
                }`}
              >
                <div className="mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-56 object-contain bg-white rounded-xl border-2 border-yellow-100 p-2"
                  />
                </div>

                <div className="mb-6">
                  <h4 className="text-lg font-bold text-gray-800">{testimonial.name}</h4>
                  <p className="text-yellow-600 font-medium text-sm">{testimonial.designation}</p>
                  <p className="text-gray-600 text-sm">{testimonial.project}</p>
                </div>
                
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                <blockquote className="text-gray-600 italic leading-relaxed">
                  "{testimonial.comment}"
                </blockquote>
                
                <div className="mt-6 pt-4 border-t border-gray-100">
                  <span className="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium">
                    {testimonial.category}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {allTestimonials.length === 0 && (
            <div className="text-center py-16">
              <div className="w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Quote className="h-12 w-12 text-yellow-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">No Testimonials Found</h3>
              <p className="text-gray-600 max-w-md mx-auto">
                Try selecting a different category to view customer testimonials.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-yellow-600 to-yellow-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Create Your Success Story?
          </h2>
          <p className="text-xl text-yellow-100 mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied customers who chose NPSH Developers for their dream projects. 
            Let us help you build something extraordinary.
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <MessageCircle className="mr-2 h-6 w-6" />
            Share Your Vision With Us
          </button>
        </div>
      </section>
    </div>
  );
};

export default TestimonialsPage;